<div class="insert-password">
  <p class="insert-password_title">
    {{ 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.TITLE' | translate }}
  </p>
  <p class="insert-password_description">
    {{ 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.DESCRIPTION' | translate }}
  </p>

  <div class="insert-password__container">
    <input
      class="insert-password__container-input"
      [type]="showPassword ? 'text' : 'password'"
      autocomplete="current-password"
      aria-describedby="password-constraints"
      [formControl]="passwordControl"
      [placeholder]="'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.PLACEHOLDER' | translate"
    />

    <button
      class="insert-password__container-suffix"
      mat-icon-button
      type="button"
      (click)="showPassword = !showPassword"
      [matTooltip]="
        (showPassword
          ? 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.SHOW'
          : 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.HIDE'
        ) | translate
      "
      [matTooltipPosition]="'right'"
    >
      <mat-icon> {{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
    </button>
  </div>

  <div *ngIf="passwordControl.touched">
    <p class="insert-password__container-error" *ngIf="passwordControl.hasError('required')">
      {{ 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.ERRORS.REQUIRED' | translate }}
    </p>

    <p class="insert-password__container-error" *ngIf="passwordControl.hasError('incorrect')">
      {{ 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.ERRORS.INCORRECT' | translate }}
    </p>
  </div>

  <div class="insert-password__buttons">
    <button
      mat-raised-button
      class="insert-password__buttons-button insert-password__buttons-button--white"
      [disabled]="isLoading"
      (click)="back.emit()"
    >
      {{
        (isClose ? 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.CLOSE' : 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.BACK')
          | translate
      }}
    </button>

    <button
      mat-raised-button
      class="insert-password__buttons-button"
      [disabled]="passwordControl.invalid || isLoading"
      (click)="generateTemporaryToken()"
    >
      {{ 'PROFILE.DIALOGS.EDIT_MFA.INSERT_PASSWORD.NEXT' | translate }}
    </button>
  </div>
</div>
